var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hisworks" }, [
    _c("div", { staticClass: "worksWarp" }, [
      _c(
        "div",
        { staticClass: "worksMain" },
        [
          _c("RealTitle", {
            attrs: { titleInfo: _vm.titleInfo, backPath: _vm.backPath },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "showreel" }, [
            _c("div", { staticClass: "showreelInfo" }, [
              _c("video", {
                attrs: {
                  src: _vm.work.contentFile,
                  controls: "",
                  autoplay: "",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "showreelRightWarp" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "showreelItem" },
                _vm._l(_vm.workList, function (i, j) {
                  return _c(
                    "li",
                    {
                      key: j,
                      on: {
                        click: function ($event) {
                          return _vm.switchWork(i)
                        },
                      },
                    },
                    [
                      _c("img", { attrs: { src: i.imgSrc, alt: "" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "视频" + _vm._s(j + 1) + ":" + _vm._s(i.videoName)
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "worksInfo" }, [
            _c("h4", [_vm._v(_vm._s(_vm.work.workName))]),
            _vm._v(" "),
            _c("ul", { staticClass: "infoDesc" }, [
              _c("li", [
                _c("i", { staticClass: "el-icon-office-building" }),
                _vm._v(" "),
                _c("span", [
                  _c("b", [_vm._v("所属教育局：")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.work.bureauName) +
                      "\n              "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", { staticClass: "el-icon-school" }),
                _vm._v(" "),
                _c("span", [
                  _c("b", [_vm._v("所属学校：")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.work.schoolName) +
                      "\n              "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", { staticClass: "el-icon-notebook-1" }),
                _vm._v(" "),
                _c("span", [
                  _c("b", [_vm._v("所属大类：")]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.work.categoryName) +
                      "\n              "
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "showreelRightTitle" }, [
      _c("i", { staticClass: "el-icon-data-line" }),
      _vm._v(" "),
      _c("span", [_vm._v("相关推荐")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }